module.exports = __webpack_public_path__ + "static/img/user-propile-level01.96cc9c97.svg";